export default __webpack_public_path__ + "static/media/PhoneIcon.465dcdd9.svg";